// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import iView from "iview";
import 'iview/dist/styles/iview.css';
import Headers from '@/components/common/head.vue';
import '@/assets/css/common.css';
import { Message } from 'iview';
import Fetch from '@/api/fetch.js';
import API from '@/api/api.js'; 
// import install from '@/assets/js/public.js';
// Vue.use(install)
Vue.component("Headers", Headers);
Vue.prototype.$message = Message;
Vue.prototype.$api=API;
Vue.prototype.$fetch = Fetch;
Vue.prototype.$status = status;
Vue.config.productionTip = false;
Vue.use(iView);

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js